
@if (selectedItem) {
  <form  [formGroup]="form" (ngSubmit)="save(selectedItem)">
    <p-panel>
      <p-header>
        @if (selectedItem.id) {
          <h2>Editing '{{originalName}}'</h2>
        }
        @if (!selectedItem.id) {
          <h2>Create New {{entityName}}</h2>
        }
      </p-header>
      <div class="grid flex-row flex-wrap gap-3 align-content-center justify-content-start">
        <!-- Item specifics start here -->
        <div class="col-1">
          <mat-form-field class="full-width">
            <mat-label>Person ID</mat-label>
            <input matInput class="full-width" type="text" id="personID" formControlName="identity" readonly/>
          </mat-form-field>
        </div>
        <div class="col-2">
          <!-- dividerColor="{{ !form.controls.firstName.valid ? 'warn' : 'primary' }}" -->
          <mat-form-field class="full-width" >
            <mat-label>First name</mat-label>
            <input matInput [readonly]="isFieldReadonly('firstName')" class="full-width" type="text" id="firstName" formControlName="firstName" required />
            @if (!form.controls.firstName.valid) {
              <mat-hint align="start" [class.alert-danger]="!form.controls.firstName.valid">First name must not be empty</mat-hint>
            }
          </mat-form-field>
        </div>
        <div class="col-2">
          <!-- dividerColor="{{ !form.controls.lastName.valid ? 'warn' : 'primary' }}" -->
          <mat-form-field class="full-width" >
            <mat-label>Last name</mat-label>
            <input matInput [readonly]="isFieldReadonly('lastName')" class="full-width" type="text" id="lastName"
              required formControlName="lastName" name="lastName" />
            @if (!form.controls.lastName.valid) {
              <mat-hint align="start" [class.alert-danger]="!form.controls.lastName.valid">Last name must not be empty</mat-hint>
            }
          </mat-form-field>
        </div>
        <div class="col-2 company-select" [formGroup]="$any(form.controls.tfCompany)">
          <mat-form-field class="full-width">
            <mat-label>Company</mat-label>
            <mat-select class="full-width" formControlName="id" required>
              @for (company of tfCompanies; track company) {
                <mat-option [value]="company.id">{{ company.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-2">
          <mat-form-field class="full-width">
            <mat-label>Nationality</mat-label>
            <input matInput [readonly]="isFieldReadonly('nationality')" type="text" id="nationality" formControlName="nationality"
              name="nationality"/>
          </mat-form-field>
        </div>
        <div class="col-2">
          <mat-form-field class="full-width">
            <mat-label>Rijksregisternummer</mat-label>
            <input matInput [readonly]="isFieldReadonly('rijksregisternummer')" type="text" id="rijksregisternummer" formControlName="rijksregisternummer"
              name="rijksregisternummer"/>
          </mat-form-field>
        </div>
        <p-tabs class="col-12">
          <p-tablist>
            <p-tab value="0"><i class="fa fa-id-badge"></i>Personal info</p-tab>
          </p-tablist>
          <p-tabpanels>
          <p-tabpanel >
            <div class="grid flex-row gap-3">
              <div class="col-3 grid flex-wrap flex-column align-content-stretch">
                <p-panel class="col-12">
                  <p-header>Access rights</p-header>
                  <mat-checkbox formControlName="pickup" class="col-12" aria-label="pickup">PickUp flow</mat-checkbox>
                  <mat-checkbox formControlName="dropoff" class="col-12" aria-label="dropodd">DropOff flow</mat-checkbox>
                  <mat-checkbox formControlName="p12p13" class="col-12" aria-label="p12p13">P12/P13 flow</mat-checkbox>
                  <mat-checkbox formControlName="isBrigadier" class="col-12 brigadier" aria-label="isBrigadier">Brigadier</mat-checkbox>
                  <div class="clearfix"></div>
                </p-panel>
                <p-panel class="col-12">
                  <p-header>Badge ( {{badgeStatus}} )</p-header>
                  <mat-form-field class="full-width">
                    <mat-label>Person's badge ID</mat-label>
                    <input matInput type="text" formControlName="keyRFID" type="text" id="keyRFID" name="keyRFID">
                    @if (!form.controls.keyRFID.valid) {
                      <mat-hint align="start" [class.alert-danger]="!form.controls.keyRFID.valid">{{form.controls.keyRFID.errors?.error}}</mat-hint>
                    }
                  </mat-form-field>
                </p-panel>
              </div>
              <p-panel class="col-3 grid flex-wrap flex-column align-content-stretch">
                <p-header>Blacklist</p-header>
                <node-blacklisting class="flex-auto" [form]="$any(form.controls.blacklisting)"></node-blacklisting>
                <div class="clearfix"></div>
              </p-panel>
              <node-address class="col-6 grid flex-wrap flex-column align-content-stretch" [readonly]="isFieldReadonly('address')" [form]="$any(form.controls.address)">
                <div class="col-3">
                  <mat-form-field class="full-width">
                    <mat-label>GSM number</mat-label>
                    <input matInput [readonly]="isFieldReadonly('phone')" class="full-width" type="text"
                      formControlName="phone" name="phone"/>
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field class="full-width">
                    <mat-label>E-mail</mat-label>
                    <input matInput [readonly]="isFieldReadonly('email')" class="full-width" type="text"
                      formControlName="email" name="email" />
                  </mat-form-field>
                </div>
                <div class="col-5 flex-auto">
                  <mat-form-field class="full-width">
                    <mat-label>Birth date</mat-label>
                    <input matInput [matDatepicker]="picker" readonly formControlName="birthDate">
                    @if (!isFieldReadonly('birthDate')) {
                      <mat-datepicker-toggle mdSuffix [for]="$any(picker)"></mat-datepicker-toggle>
                    }
                    <mat-datepicker #picker [startAt]="bdStartDate" (selectedChanged)="setBirthDate($event)"></mat-datepicker>
                  </mat-form-field>
                </div>
              </node-address>
            </div>
          </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
        <!-- Item specifics end here -->
      </div>
      <div class="clearfix"></div>
      @if (errorMsgs?.length) {
        <ul class="col-12" class="alert alert-danger">
          @for (err of errorMsgs; track err) {
            <li>{{err}}</li>
          }
        </ul>
      }
      <p-footer>
        <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">Submit</button>
        <button mat-raised-button (click)="cancel(selectedItem)" type="button">Cancel</button>
      </p-footer>
    </p-panel>
  </form>
}

@if (debug) {
  <div class="col-12">
    <pre>{{ debug | json }}</pre>
  </div>
}


@if (!selectedItem) {
  <div>{{entityName}} does not exists</div>
}

